<template>
  <div id="app">
    <WebGLCanvas ref="canvas" v-on:on-animation-frame="fireworkSceneUpdate">
      <div class="controls">
      <button class="launch" v-on:click="launch">Let's Party!</button>
      <button class="launch2" v-on:click="launch2">Party Harder!</button>
      </div>
      <!-- <DrawFirework v-on:update-firework="updateFirework"><button v-on:click="launch3">launch</button></DrawFirework> -->
    </WebGLCanvas>
  </div>
</template>

<script>
// import * as Three from 'three';

import FireworksScene from './objects/Scene'

import WebGLCanvas from './components/WebGLCanvas.vue'
import DrawFirework from './components/DrawFirework.vue'
import Store from './store'
import { FireworkEffect } from './effects/FireworkEffect'
import Firework from './objects/Firework/Firework'

const Three = require('three')
const fireworksScene = new FireworksScene()
window.scene = new Three.Scene()
window.effects = []
export default {
  name: 'app',
  store: Store,
  data () {
    return {
      windowWidth: 0,
      windowHeight: 0,
      firework: {}
    }
  },
  components: {
    WebGLCanvas,
    DrawFirework
  },
  mounted () {
    this.$nextTick(() => {
      // Build the Three.js scene:
      this.$refs.canvas.addObject(fireworksScene)
      this.fwEffect = new FireworkEffect()
      this.$refs.canvas.addEffect(this.fwEffect)
    })
  },
  methods: {
    launch () {
      fireworksScene.addFirework()
    },
    launch2 () {
      fireworksScene.addFireworkSpread()
    },
    launch3 () {
      let firework = new Firework()
      firework.setSubcomponentTemplate(this.firework)
      fireworksScene.addFirework(firework)
    },
    fireworkSceneUpdate (timeStamp) {
      fireworksScene.update(timeStamp)
      this.fwEffect.setFireworkPoints(this.$refs.canvas.camera, fireworksScene.getFireworkPoints())
    },
    updateFirework (val) {
      this.firework = val
    }
  }

}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  overflow: hidden;
}
.launch {
  background-color:#44c767;
  -moz-border-radius:28px;
  -webkit-border-radius:28px;
  border-radius:28px;
  border:1px solid #18ab29;
  display:inline-block;
  cursor:pointer;
  color:#ffffff;
  font-family:Courier New;
  font-size:17px;
  font-weight:bold;
  padding:9px 31px;
  text-decoration:none;
  text-shadow:0px 1px 0px #2f6627;
}
.launch:hover {
  background-color:#5cbf2a;
}
.launch2 {
  background-color:#db902e;
  -moz-border-radius:28px;
  -webkit-border-radius:28px;
  border-radius:28px;
  border:1px solid #c07c22;
  display:inline-block;
  cursor:pointer;
  color:#ffffff;
  font-family:Courier New;
  font-size:17px;
  font-weight:bold;
  padding:9px 31px;
  text-decoration:none;
  text-shadow:0px 1px 0px #865719;
}
.launch2:hover {
  background-color:#c07c22;
}
.controls {
  position: absolute;
    bottom: 0px;
  left: 50%;
  transform: translate(-50%, 0%);
  padding: 10px
}
@media (max-width:  576px)
{
  .controls {
    width: 100%;
  }
  .launch, .launch2{
    /* font-size: 12px; */
    max-width: 120px;
    text-align: center;
  }
  .launch {
    float: left;
  }
  .launch2 {
    float: right;
  }
}
</style>
